import $ from "jquery";

// Pagination controls HTML to be appended to the `.pagination element.
const paginationControls = `<div class="[ pagination ] flex items-center my-4 tablet:justify-center mobile:w-full col-span-full"
    role="navigation"
    aria-label="Pagination Navigation"
    data-ktc-search-exclude>
    <div class="[ paging ] flex items-center justify-center me-ch-2 tablet-sm:hidden">
        <span class="[ paging-label ]">Showing:</span>
        <select class="[ paging-select ] font-medium border-0 pe-4 focus:ring-0 min-w-[4.5rem]"></select>
        <span class="pe-ch-1">of</span>
        <span class="[ paging-count ] font-medium"></span>
        <span class="[ paging-change ]"></span>
    </div>
    <a class="[ pagination-direction pagination-prev ] flex items-center cursor-pointer transition-colors me-3 hover:no-underline" rel="prev">
        <i class="[ i-chevron-left ] text-main-500 text-20 me-2" aria-hidden="true"></i>
        <span class="[ pagination-directionLabel ] font-medium font-futura tracking-wide mobile:hidden">Previous</span>
    </a>
    <div class="[ pagination-number ] flex items-center justify-center cursor-pointer h-6 transition-colors hover:no-underline"></div>
    <a class="[ pagination-direction pagination-next  ] flex items-center cursor-pointer transition-colors ms-3 hover:no-underline" rel="next">
        <span class="[ pagination-directionLabel ] font-medium font-futura tracking-wide mobile:hidden">Next</span>
        <i class="[ i-chevron-right ] text-main-500 text-20 ms-2" aria-hidden="true"></i>
    </a>
</div>`;

window.InitializePaginations = function () {
    $(".pagination-list").each(function () {
        const $paginationElem = $(this);
        if ($paginationElem.hasClass("pagination-initialized")) return;

        $paginationElem.addClass("pagination-initialized");

        const perView = Number($paginationElem.attr("data-per-view")) || 10;
        let totalChildren = $(".pagination-item", $paginationElem).length;
        let totalPages = Math.ceil(totalChildren / perView);

        if (totalPages <= 1) return;
        let currentPage = 1;

        // Append and initialize the pagination controls element
        const $paginationControls = $(paginationControls).appendTo($paginationElem);

        // function sets the pagination page
        function selectPage(page: number) {
            totalChildren = $(
                ".pagination-item.is-filtered,.pagination-item:not(:has(.filter-item))",
                $paginationElem
            ).length;
            totalPages = Math.ceil(totalChildren / perView);

            if (totalPages <= 1) {
                page = 1;
                currentPage = 1;

                $paginationControls.attr("aria-hidden", "true").hide();
            } else {
                $paginationControls.attr("aria-hidden", "false").show();
            }

            $(".paging-count", $paginationElem).text(totalPages);
            const select = $(".paging-select", $paginationElem);
            select.empty();
            for (let i = 0; i < totalPages; i++)
                select.append(
                    $("<option>")
                        .val(i + 1)
                        .text(i + 1)
                );

            // Calculate the start and end index of the page list to be displayed
            const pageStart = Math.max(Math.min(currentPage - 2, totalPages - 4), 1);
            const pageDisplayLength = Math.min(totalPages, 5);
            const range = (start: number, end: number, length = end - start + 1) =>
                Array.from({ length }, (_, i) => start + i);

            $(".pagination-number", $paginationElem).empty();

            for (const c of range(pageStart, totalPages, pageDisplayLength)) {
                $(".pagination-number", $paginationElem).append(
                    `<span data-page="${c}" class="[ pagination-digit ] flex items-center justify-center cursor-pointer border-2 min-w-6 h-6 transition-colors mx-1 px-1 border-transparent hover:no-underline hover:border-gray-500">${c}</span>`
                );
            }

            $(`.pagination-number [data-page="${currentPage}"]`, $paginationElem)
                .addClass("page-is-active")
                .attr("aria-current", "page");

            const items = $(".pagination-item", $paginationElem);
            $(items).removeClass("is-visible").attr("aria-hidden", "true").attr("hidden", "true");
            const paginationItem = $(items).slice((page - 1) * perView, page * perView);
            $(paginationItem).addClass("is-visible").attr("aria-hidden", "false").removeAttr("hidden");

            $(".pagination-direction", $paginationElem).removeClass("is-disabled");

            if (currentPage <= 1) $(".pagination-prev", $paginationElem).addClass("is-disabled");

            if (totalPages == 0 || currentPage === totalPages)
                $(".pagination-next", $paginationElem).addClass("is-disabled");

            $(".paging-select", $paginationElem).val(currentPage);
        }

        // Select pagination page from select
        $paginationElem.on("change", ".paging-select", function () {
            const element = this as HTMLInputElement;
            currentPage = parseInt(element.value);
            selectPage(currentPage);
        });

        // Select pagination page from pagination-digit
        $paginationElem.on("click", ".pagination-digit", function () {
            currentPage = $(this).data("page") as number;
            selectPage(currentPage);
        });

        // Previous page control
        $paginationElem.on("click", ".pagination-prev", function () {
            currentPage--;
            selectPage(currentPage);
        });

        // Next page control
        $paginationElem.on("click", ".pagination-next", function () {
            currentPage++;
            selectPage(currentPage);
        });

        // empty element to attach a refresh event
        $paginationElem.on("click", ".paging-change", function () {
            selectPage(currentPage);
        });
    });

    // Filter selection
    $("[data-filter]").each(function () {
        $(this).on("input", function () {
            filterList();
        });
    });

    function filterList() {
        const filterValues: { [key: string]: string[] } = {};
        const searchValues: { [key: string]: string[] } = {};

        $("input[data-filter]:checked, select[data-filter]").each(function (): void {
            const filter = $(this).data("filter") as string;
            const value = $(this).val()?.toString();
            if (filter && value) {
                if (!filterValues[filter]) filterValues[filter] = [];

                filterValues[filter].push(value);
            }
        });

        $("input[data-filter][type='text']").each(function (): void {
            const filter = $(this).data("filter") as string;
            const value = $(this).val()?.toString();
            if (filter && value) {
                if (!searchValues[filter]) searchValues[filter] = [];

                searchValues[filter].push(value);
            }
        });

        $(".filter-clear").each(function (_, item) {
            const $item = $(item);
            const filter = $item.data("filter") as string;
            const filterValue = $item.prop("value") as string;

            if (
                Object.keys(filterValues).some(
                    (key) => filter === key && (filterValues[key] ?? []).includes(filterValue)
                ) ||
                Object.keys(searchValues).includes(filter)
            ) {
                $item.attr("aria-hidden", "false").removeAttr("hidden");
            } else {
                $item.attr("aria-hidden", "true").attr("hidden", "true");
            }
        });

        $(".filter-item").each(function (_, item) {
            const $item = $(item);
            const isFilterIncluded = Object.keys(filterValues).every((key) =>
                (filterValues[key] ?? []).some((value) => {
                    const itemValues = (($item.data(key) as string | undefined) ?? "").split(";");
                    return itemValues.includes(value);
                })
            );

            const isSearchIncluded = Object.keys(searchValues).every((key) =>
                (searchValues[key] ?? []).some((value) => {
                    const itemValues = (($item.data(key) as string | undefined) ?? "").split(";");
                    return itemValues.some((itemValue: string) =>
                        itemValue.trim().toLowerCase().includes(value.trim().toLowerCase())
                    );
                })
            );

            const isIncluded = isFilterIncluded && isSearchIncluded;

            $item.toggleClass("is-filtered", isIncluded);
            $item.toggleClass("is-visible", isIncluded);
            $item.toggleClass("pagination-item", isIncluded);
        });

        $(".paging-change").trigger("click");
        $(".paging-select").val("1");
        $(".paging-select").trigger("change");

        if ($(".pagination-item.is-visible").length === 0)
            $(".pagination-empty").attr("aria-hidden", "false").removeAttr("hidden");
        else $(".pagination-empty").attr("aria-hidden", "true").attr("hidden", "true");
    }

    const initialSortValue = $(".pagination-sort").first().val()?.toString();
    const initialSort = initialSortValue?.split(",");
    if (initialSort && initialSort.length >= 2) {
        const [srt, dir] = initialSort;
        if (srt && dir) sortList(srt, dir);
    }

    filterList();
};

$(".filter-clear").on("click", function () {
    const filterValue = $(this).prop("value") as string;
    $(`[data-filter][value="${filterValue}"][type='checkbox']`).prop("checked", false);
    $("select[data-filter],input[data-filter][type='text']").prop("value", "");

    $("[data-filter]:first").trigger("input");
});

$(".filter-clearAll").on("click", function () {
    $("[data-filter][type='checkbox'").prop("checked", false);
    $("select[data-filter],input[data-filter][type='text']").prop("value", "");

    $("[data-filter]:first").trigger("input");
});

function compare($element1: JQuery<HTMLElement>, $element2: JQuery<HTMLElement>, srt: string, dir: string): number {
    const keyA = $element1.attr(`data-${srt}`) ?? "";
    const keyB = $element2.attr(`data-${srt}`) ?? "";

    const numberA = Number(keyA);
    const numberB = Number(keyB);

    // Do we need to compare numbers?
    if (!isNaN(numberA) && !isNaN(numberB)) {
        const num1 = Number(keyA);
        const num2 = Number(keyB);

        return dir === "asc" ? num2 - num1 : num1 - num2;
    }

    return dir === "asc" ? keyB.localeCompare(keyA) : keyA.localeCompare(keyB);
}

function sortList(srt: string, dir: string) {
    const defaultSrt = $(".pagination-list").data("sort-default") as string;
    const paginationItems = $(".pagination-list > .pagination-item").toArray();
    paginationItems.sort(function (a, b) {
        const $a = $(a);
        const $b = $(b);
        const result = compare($a, $b, srt, dir);
        return result != 0 ? result : compare($a, $b, defaultSrt, "asc");
    });

    $.each(paginationItems, function (_, row) {
        $(".pagination-list").prepend(row);
    });

    $(".paging-change").trigger("click");
    $(".paging-select").val("1");
    $(".paging-select").trigger("change");
}

$(".pagination-sort").on("change", function () {
    const input = this as HTMLInputElement;
    const sorted = input.value.split(",");
    if (sorted.length >= 2 && sorted[0] && sorted[1]) sortList(sorted[0], sorted[1]);
});

$(window.InitializePaginations);
